export default {
    nav: {
        brand: 'travellingdominika',
        services: 'Usługi',
        portfolio: 'Portfolio',
        contact: 'Kontakt',
    },
    hero: {
        taglineLabel: 'TUTAJ',
        taglineTitle: 'Dominika',
        taglineSubLine1: 'Twórczyni treści,',
        taglineSubLine2: 'które przyciągają uwagę.',
        socialsLabel: 'POZNAJ MNIE LEPIEJ',
    },
    intro: {
        label: 'O MNIE',
        greet: 'Witaj / hej!',
        title: 'Tutaj Dominika.',
        body1: 'Tworzę kreatywny content, podróżuję po świecie, odpoczywam w naturze i łapię w obiektywie aparatu piękne momenty.',
        body2: 'Do życia inspirują mnie nowe doświadczenia, piękne miejsca, góry i ciekawi ludzie.',
        expandCta: 'Poznaj mnie lepiej',
        collapseCta: 'Schowaj',
        longBioLabel: 'DŁUŻSZA HISTORIA',
        instagramTitle: 'Najnowszy post na Instagramie',
        longBio: [
            'Mam na imię Dominika. Do życia inspirują mnie częste podróże, nowe miejsca, piękne wnętrza, natura i kulinaria.',
            'Z zawodu jestem elektroradiologiem, jednak z zamiłowania i pasji do kreatywnego tworzenia, zostałam content creatorem i social media managerem. Mam ponad 6-letnie doświadczenie w branży marketingu i mediów społecznościowych.',
            'Na co dzień pracuję w agencji marketingu medycznego jako social media specialist oraz działam z klientami i markami, rozwijając im social media lub dostarczając kreatywny content.',
            'Moim ulubionym elementem pracy jest tworzenie materiałów kreatywnych dla branży turystycznej, podróżniczej i hotelowej. To praca, która wypełnia mnie mnóstwem pozytywnej energii, uwielbiam chwytać piękne momenty w kadry zdjęciowe, bawić się światłem i upamiętniać dzięki aparatowi historie, emocje, opowieść.',
            'Do swoich projektów podchodzę zawsze kompleksowo, tworzę mapę inspiracji i szukam pomysłów na to, aby przekaz w materiałach był bardzo autentyczny.',
            'Odkrywanie nowych miejsc to moja ogromna pasja, dlatego każda podróż to dla mnie pełna inspiracji przygoda.',
            'Uwielbiam naturę w Szwajcarii, kocham włoskie la dolce vita, zakochałam się w kulturze w Japonii i ogromnie doceniam kulinaria oraz lokalność Polski.',
            'W swojej pracy cenię sobie to, że każdy dzień daje mi nową kartę, która pobudza mnie kreatywnie.',
        ],
    },
    services: {
        label: 'USŁUGI',
        headlinePre: 'Dwie drogi,',
        headlineItalic: 'jak możemy',
        headlinePost: 'razem pracować.',
        ugc: {
            tag: 'Content creation.',
            titlePre: 'Treści',
            titleItalic: 'tworzone',
            titlePost: 'z pomysłem.',
            intro: 'Pokaż, dlaczego Twoje miejsce jest wyjątkowe, a ja zajmę się złapaniem tej magii w obiektywie.',
            body: 'Tworzę materiały dla hoteli, miast, regionów turystycznych, lokalnych biznesów, restauracji, kawiarni i marek produktowych.',
            stat: '60+',
            statLabel: 'zadowolonych klientów',
        },
        manage: {
            tag: 'Social Media Management.',
            titlePre: 'Prowadzę',
            titleItalic: 'cały',
            titlePost: 'feed.',
            intro: 'Opowiedz mi o potrzebach dla swojego biznesu, a ja kompleksowo poprowadzę dla Ciebie media społecznościowe.',
            body: 'Poprowadzę kompleksowo dla Twojego biznesu profile na Instagramie, Facebooku, LinkedIn czy TikToku.',
            stat: '6+ lat',
            statLabel: 'doświadczenia w prowadzeniu mediów społecznościowych',
        },
    },
    pricing: {
        label: 'PAKIETY',
        title: 'Przykładowe pakiety usług.',
        sub: 'Cennik do indywidualnego ustalenia, jestem otwarta na stworzenie spersonalizowanej oferty.',
        currency: 'CHF',
        from: 'Od',
        items: [
            {
                name: 'Fotografia',
                price: '600',
                bullets: [
                    'Pakiet 10–50 zdjęć (ilość do ustalenia) w wysokiej jakości po edycji',
                    'Klient otrzymuje zdjęcia na własny użytek',
                ],
            },
            {
                name: 'Instagram Foto',
                price: '1200',
                bullets: [
                    'Kreatywna karuzela z 5–15 zdjęciami (ilość do ustalenia)',
                    '1 rolka lub 1 pakiet 10 zdjęć w wysokiej jakości po edycji',
                ],
            },
            {
                name: 'Instagram Video',
                price: '800',
                bullets: [
                    'Rolka 30–45 sekund (ilość rolek do ustalenia)',
                ],
            },
            {
                name: 'Foto × Travellingdominika',
                price: '600',
                bullets: [
                    "Kreatywna karuzela z 5–15 zdjęciami, we współtworzeniu z moim kontem {'@'}travellingdominika",
                ],
            },
        ],
        footer: 'Każda oferta jest ustalana indywidualnie. Jestem otwarta na negocjacje i rozmowy, napisz, a wspólnie ułożymy coś skrojonego pod Ciebie.',
    },
    realizations: {
        label: 'MOJE REALIZACJE',
        titlePre: 'Tworzę treści, które',
        titleItalic: 'opowiadają historię',
        titlePost: 'i angażują.',
        body: 'W swojej pracy cenię sobie to, że każdy dzień daje mi nową kartę, która pobudza mnie kreatywnie.',
        list: [
            { icon: 'camera', label: 'Fotografia' },
            { icon: 'film', label: 'Krótkie wideo' },
            { icon: 'pen', label: 'Kreatywne teksty' },
            { icon: 'pin', label: 'Press trips & opowiadanie historii o danym miejscu' },
            { icon: 'share', label: 'Obsługa social media' },
        ],
        cards: [
            { title: 'Hotele' },
            { title: 'Turystyka & podróże' },
            { title: 'Kulinaria & restauracje' },
            { title: 'Lokalne biznesy' },
            { title: 'Zdjęcia produktowe' },
            { title: 'Moda' },
            { title: 'Outdoor' },
        ],
        prev: 'Poprzednie',
        next: 'Następne',
    },
    stats: {
        label: 'W LICZBACH',
        title: 'Kilka lat łapania światła.',
        sub: 'Nie skupiam się głównie na liczbach, a na jakościowym, angażującym contencie, ale tutaj możesz zobaczyć odrobinę więcej o moim doświadczeniu.',
        items: [
            { value: '6+', label: 'Lat doświadczenia', sub: 'w tworzeniu contentu i prowadzeniu SM' },
            { value: '60+', label: 'Partnerstw', sub: 'klientów, brand partners i współprac' },
            { value: '1 mln+', label: 'Zasięgów', sub: "zaglądających na {'@'}travellingdominika" },
            { value: '30+', label: 'Krajów', sub: 'z których czerpałam inspiracje' },
        ],
    },
    portfolio: {
        label: 'PORTFOLIO',
        title: 'Miejsca, w których byłam.',
        hint: 'przeciągnij',
        galleryCta: 'Zobacz pełną galerię',
        items: [
            { title: 'Kyoto', place: 'Japonia' },
            { title: 'Bieszczady', place: 'Polska' },
            { title: 'Harder Kulm', place: 'Szwajcaria' },
            { title: 'Grindelwald First', place: 'Szwajcaria' },
            { title: 'Gdańsk', place: 'Polska' },
            { title: 'Lucerna', place: 'Szwajcaria' },
            { title: 'Como', place: 'Włochy' },
            { title: 'Kopenhaga', place: 'Dania' },
            { title: 'Berno', place: 'Szwajcaria' },
        ],
        closeLabel: 'Zamknij',
        prevLabel: 'Poprzednie zdjęcie',
        nextLabel: 'Następne zdjęcie',
        photoCount: 'zdjęć',
        backLabel: 'Wstecz',
        categoryTaglines: {
            hotels: "hotele, z którymi pracowałam",
            tourism: "miejsca, w których byłam",
            products: "marki, które fotografowałam",
        },
        categoryLabels: {
            hotels: 'Hotele',
            tourism: 'Turystyka',
            products: 'Sesje produktowe',
        },
        filterLabel: 'Pokaż',
        filterAll: 'Wszystko',
        albums: [
            {
                title: "Filario",
                place: "Jezioro Como, Włochy",
                category: "hotels",
                description: "Designerski hotel nad jeziorem Como — światło tuż przy wodzie, spokojne wnętrza i rozległe widoki na jezioro.",
                cover: '/portfolio/filario/1.jpg',
                photos: [
                    '/portfolio/filario/1.jpg',
                    '/portfolio/filario/2.jpg',
                    '/portfolio/filario/3.jpg',
                    '/portfolio/filario/4.jpg',
                    '/portfolio/filario/5.jpg',
                    '/portfolio/filario/6.jpg',
                    '/portfolio/filario/7.jpg',
                    '/portfolio/filario/8.jpg',
                    '/portfolio/filario/9.jpg',
                    '/portfolio/filario/10.jpg',
                    '/portfolio/filario/11.jpg',
                    '/portfolio/filario/12.jpg',
                    '/portfolio/filario/13.jpg',
                    '/portfolio/filario/14.jpg',
                    '/portfolio/filario/15.jpg',
                    '/portfolio/filario/16.jpg',
                    '/portfolio/filario/17.jpg',
                    '/portfolio/filario/18.jpg',
                    '/portfolio/filario/19.jpg',
                    '/portfolio/filario/20.jpg',
                    '/portfolio/filario/21.jpg',
                    '/portfolio/filario/22.jpg',
                    '/portfolio/filario/23.jpg',
                    '/portfolio/filario/24.jpg',
                    '/portfolio/filario/25.jpg',
                    '/portfolio/filario/26.jpg',
                    '/portfolio/filario/27.jpg',
                    '/portfolio/filario/28.jpg',
                    '/portfolio/filario/29.jpg',
                    '/portfolio/filario/30.jpg',
                    '/portfolio/filario/31.jpg',
                    '/portfolio/filario/32.jpg',
                    '/portfolio/filario/33.jpg',
                    '/portfolio/filario/34.jpg',
                    '/portfolio/filario/35.jpg',
                    '/portfolio/filario/36.jpg',
                    '/portfolio/filario/37.jpg',
                    '/portfolio/filario/38.jpg',
                    '/portfolio/filario/39.jpg',
                    '/portfolio/filario/40.jpg',
                    '/portfolio/filario/41.jpg',
                ],
            },
            {
                title: "Guesthouse Castagnola",
                place: "Castagnola, Lugano",
                category: "hotels",
                description: "Butikowy guesthouse w Castagnoli nad jeziorem Lugano — śródziemnomorski luz, ciepłe pokoje i subtropikalne ogrody.",
                cover: '/portfolio/guesthouse-castagnola/1.jpg',
                photos: [
                    '/portfolio/guesthouse-castagnola/1.jpg',
                    '/portfolio/guesthouse-castagnola/2.jpg',
                    '/portfolio/guesthouse-castagnola/3.jpg',
                    '/portfolio/guesthouse-castagnola/4.jpg',
                    '/portfolio/guesthouse-castagnola/5.jpg',
                    '/portfolio/guesthouse-castagnola/6.jpg',
                    '/portfolio/guesthouse-castagnola/7.jpg',
                    '/portfolio/guesthouse-castagnola/8.jpg',
                    '/portfolio/guesthouse-castagnola/9.jpg',
                    '/portfolio/guesthouse-castagnola/10.jpg',
                    '/portfolio/guesthouse-castagnola/11.jpg',
                    '/portfolio/guesthouse-castagnola/12.jpg',
                    '/portfolio/guesthouse-castagnola/13.jpg',
                    '/portfolio/guesthouse-castagnola/14.jpg',
                    '/portfolio/guesthouse-castagnola/15.jpg',
                    '/portfolio/guesthouse-castagnola/16.jpg',
                    '/portfolio/guesthouse-castagnola/17.jpg',
                    '/portfolio/guesthouse-castagnola/18.jpg',
                    '/portfolio/guesthouse-castagnola/19.jpg',
                    '/portfolio/guesthouse-castagnola/20.jpg',
                    '/portfolio/guesthouse-castagnola/21.jpg',
                    '/portfolio/guesthouse-castagnola/22.jpg',
                    '/portfolio/guesthouse-castagnola/23.jpg',
                    '/portfolio/guesthouse-castagnola/24.jpg',
                ],
            },
            {
                title: "Salotto Brè",
                place: "Brè, Lugano",
                category: "hotels",
                description: "Klimatyczne miejsce w wiosce Brè nad Lugano — rustykalny urok Ticino i widoki na jezioro.",
                cover: '/portfolio/salotto-bre/1.jpg',
                photos: [
                    '/portfolio/salotto-bre/1.jpg',
                    '/portfolio/salotto-bre/2.jpg',
                    '/portfolio/salotto-bre/3.jpg',
                    '/portfolio/salotto-bre/4.jpg',
                    '/portfolio/salotto-bre/5.jpg',
                    '/portfolio/salotto-bre/6.jpg',
                    '/portfolio/salotto-bre/7.jpg',
                    '/portfolio/salotto-bre/8.jpg',
                    '/portfolio/salotto-bre/9.jpg',
                    '/portfolio/salotto-bre/10.jpg',
                    '/portfolio/salotto-bre/11.jpg',
                    '/portfolio/salotto-bre/12.jpg',
                    '/portfolio/salotto-bre/13.jpg',
                    '/portfolio/salotto-bre/14.jpg',
                    '/portfolio/salotto-bre/15.jpg',
                ],
            },
            {
                title: "Lugano",
                place: "Lugano, Szwajcaria",
                category: "tourism",
                description: "Materiały z Lugano i Ticino — nadjeziorne promenady, śródziemnomorskie światło i spokojny rytm szwajcarskiego południa.",
                cover: '/portfolio/lugano-tourism/1.jpg',
                photos: [
                    '/portfolio/lugano-tourism/1.jpg',
                    '/portfolio/lugano-tourism/2.jpg',
                    '/portfolio/lugano-tourism/3.jpg',
                    '/portfolio/lugano-tourism/4.jpg',
                    '/portfolio/lugano-tourism/5.jpg',
                    '/portfolio/lugano-tourism/6.jpg',
                    '/portfolio/lugano-tourism/7.jpg',
                    '/portfolio/lugano-tourism/8.jpg',
                    '/portfolio/lugano-tourism/9.jpg',
                    '/portfolio/lugano-tourism/10.jpg',
                    '/portfolio/lugano-tourism/11.jpg',
                    '/portfolio/lugano-tourism/12.jpg',
                    '/portfolio/lugano-tourism/13.jpg',
                    '/portfolio/lugano-tourism/14.jpg',
                    '/portfolio/lugano-tourism/15.jpg',
                    '/portfolio/lugano-tourism/16.jpg',
                    '/portfolio/lugano-tourism/17.jpg',
                    '/portfolio/lugano-tourism/18.jpg',
                    '/portfolio/lugano-tourism/19.jpg',
                    '/portfolio/lugano-tourism/20.jpg',
                    '/portfolio/lugano-tourism/21.jpg',
                    '/portfolio/lugano-tourism/22.jpg',
                    '/portfolio/lugano-tourism/23.jpg',
                    '/portfolio/lugano-tourism/24.jpg',
                    '/portfolio/lugano-tourism/25.jpg',
                    '/portfolio/lugano-tourism/26.jpg',
                    '/portfolio/lugano-tourism/27.jpg',
                    '/portfolio/lugano-tourism/28.jpg',
                    '/portfolio/lugano-tourism/29.jpg',
                    '/portfolio/lugano-tourism/30.jpg',
                    '/portfolio/lugano-tourism/31.jpg',
                    '/portfolio/lugano-tourism/32.jpg',
                    '/portfolio/lugano-tourism/33.jpg',
                    '/portfolio/lugano-tourism/34.jpg',
                    '/portfolio/lugano-tourism/35.jpg',
                    '/portfolio/lugano-tourism/36.jpg',
                    '/portfolio/lugano-tourism/37.jpg',
                    '/portfolio/lugano-tourism/38.jpg',
                    '/portfolio/lugano-tourism/39.jpg',
                    '/portfolio/lugano-tourism/40.jpg',
                    '/portfolio/lugano-tourism/41.jpg',
                    '/portfolio/lugano-tourism/42.jpg',
                    '/portfolio/lugano-tourism/43.jpg',
                    '/portfolio/lugano-tourism/44.jpg',
                    '/portfolio/lugano-tourism/45.jpg',
                    '/portfolio/lugano-tourism/46.jpg',
                    '/portfolio/lugano-tourism/47.jpg',
                    '/portfolio/lugano-tourism/48.jpg',
                    '/portfolio/lugano-tourism/49.jpg',
                    '/portfolio/lugano-tourism/50.jpg',
                    '/portfolio/lugano-tourism/51.jpg',
                    '/portfolio/lugano-tourism/52.jpg',
                    '/portfolio/lugano-tourism/53.jpg',
                    '/portfolio/lugano-tourism/54.jpg',
                    '/portfolio/lugano-tourism/55.jpg',
                    '/portfolio/lugano-tourism/56.jpg',
                    '/portfolio/lugano-tourism/57.jpg',
                    '/portfolio/lugano-tourism/58.jpg',
                    '/portfolio/lugano-tourism/59.jpg',
                    '/portfolio/lugano-tourism/60.jpg',
                ],
            },
            {
                title: "Eiger Lodge",
                place: "Grindelwald, Szwajcaria",
                category: "hotels",
                description: "Butikowy alpejski lodge u stóp Eigeru. Ciepłe wnętrza, widoki na góry i ciche poranne światło.",
                cover: '/portfolio/eiger-lodge/1.jpg',
                photos: [
                    '/portfolio/eiger-lodge/1.jpg',
                    '/portfolio/eiger-lodge/2.jpg',
                    '/portfolio/eiger-lodge/3.jpg',
                    '/portfolio/eiger-lodge/4.jpg',
                    '/portfolio/eiger-lodge/5.jpg',
                    '/portfolio/eiger-lodge/6.jpg',
                    '/portfolio/eiger-lodge/7.jpg',
                    '/portfolio/eiger-lodge/8.jpg',
                    '/portfolio/eiger-lodge/9.jpg',
                ],
            },
            {
                title: "Giardino Lago",
                place: "Locarno, Szwajcaria",
                category: "hotels",
                description: "Hotel butikowy nad Lago Maggiore, światło na wodzie i wnętrza zaprojektowane z myślą o spokoju.",
                cover: '/portfolio/giardino-lago/15.jpg',
                photos: [
                    '/portfolio/giardino-lago/1.jpg',
                    '/portfolio/giardino-lago/2.jpg',
                    '/portfolio/giardino-lago/3.jpg',
                    '/portfolio/giardino-lago/4.jpg',
                    '/portfolio/giardino-lago/5.jpg',
                    '/portfolio/giardino-lago/6.jpg',
                    '/portfolio/giardino-lago/7.jpg',
                    '/portfolio/giardino-lago/8.jpg',
                    '/portfolio/giardino-lago/9.jpg',
                    '/portfolio/giardino-lago/10.jpg',
                    '/portfolio/giardino-lago/11.jpg',
                    '/portfolio/giardino-lago/12.jpg',
                    '/portfolio/giardino-lago/13.jpg',
                    '/portfolio/giardino-lago/14.jpg',
                    '/portfolio/giardino-lago/15.jpg',
                    '/portfolio/giardino-lago/16.jpg',
                ],
            },
            {
                title: "Giardino Ascona",
                place: "Ascona, Szwajcaria",
                category: "hotels",
                description: "Klasyka Ascony, patio z drzewami oliwnymi, śródziemnomorskie detale i ciepłe popołudnia.",
                cover: '/portfolio/giardino-ascona/1.jpg',
                photos: [
                    '/portfolio/giardino-ascona/1.jpg',
                    '/portfolio/giardino-ascona/2.jpg',
                    '/portfolio/giardino-ascona/3.jpg',
                    '/portfolio/giardino-ascona/4.jpg',
                    '/portfolio/giardino-ascona/5.jpg',
                    '/portfolio/giardino-ascona/6.jpg',
                    '/portfolio/giardino-ascona/7.jpg',
                    '/portfolio/giardino-ascona/8.jpg',
                    '/portfolio/giardino-ascona/9.jpg',
                    '/portfolio/giardino-ascona/10.jpg',
                    '/portfolio/giardino-ascona/11.jpg',
                    '/portfolio/giardino-ascona/12.jpg',
                    '/portfolio/giardino-ascona/13.jpg',
                ],
            },
            {
                title: "Lucerna",
                place: "Szwajcaria",
                category: "tourism",
                description: "Lucerna w letnim świetle, jezioro, drewniane mosty i Alpy tuż za miastem.",
                cover: '/portfolio/lucerne/1.jpg',
                photos: [
                    '/portfolio/lucerne/1.jpg',
                    '/portfolio/lucerne/2.jpg',
                    '/portfolio/lucerne/3.jpg',
                    '/portfolio/lucerne/4.jpg',
                    '/portfolio/lucerne/5.jpg',
                    '/portfolio/lucerne/6.jpg',
                    '/portfolio/lucerne/7.jpg',
                    '/portfolio/lucerne/8.jpg',
                ],
            },
            {
                title: "Kulturhof Hinter Musegg",
                place: "Lucerna, Szwajcaria",
                category: "tourism",
                description: "Sesja w historycznym Kulturhof Hinter Musegg, atmosfera, detale i naturalne światło.",
                cover: '/portfolio/kulturhof/1.jpg',
                photos: [
                    '/portfolio/kulturhof/1.jpg',
                    '/portfolio/kulturhof/2.jpg',
                    '/portfolio/kulturhof/3.jpg',
                    '/portfolio/kulturhof/4.jpg',
                    '/portfolio/kulturhof/5.jpg',
                    '/portfolio/kulturhof/6.jpg',
                    '/portfolio/kulturhof/7.jpg',
                    '/portfolio/kulturhof/8.jpg',
                    '/portfolio/kulturhof/9.jpg',
                    '/portfolio/kulturhof/10.jpg',
                    '/portfolio/kulturhof/11.jpg',
                    '/portfolio/kulturhof/12.jpg',
                ],
            },
            {
                title: "Ascona",
                place: "Tessyn, Szwajcaria",
                category: "tourism",
                description: "Stare uliczki Ascony nad Lago Maggiore, pastelowe kolory i smak tessińskiego lata.",
                cover: '/portfolio/ascona/1.jpg',
                photos: [
                    '/portfolio/ascona/1.jpg',
                    '/portfolio/ascona/2.jpg',
                    '/portfolio/ascona/3.jpg',
                    '/portfolio/ascona/4.jpg',
                    '/portfolio/ascona/5.jpg',
                    '/portfolio/ascona/6.jpg',
                    '/portfolio/ascona/7.jpg',
                    '/portfolio/ascona/8.jpg',
                    '/portfolio/ascona/9.jpg',
                    '/portfolio/ascona/10.jpg',
                    '/portfolio/ascona/11.jpg',
                    '/portfolio/ascona/12.jpg',
                ],
            },
            {
                title: "Locarno",
                place: "Tessyn, Szwajcaria",
                category: "tourism",
                description: "Locarno w letnim świetle, Piazza Grande, jezioro i klimat południa Szwajcarii.",
                cover: '/portfolio/locarno/1.jpg',
                photos: [
                    '/portfolio/locarno/1.jpg',
                    '/portfolio/locarno/2.jpg',
                    '/portfolio/locarno/3.jpg',
                    '/portfolio/locarno/4.jpg',
                    '/portfolio/locarno/5.jpg',
                    '/portfolio/locarno/6.jpg',
                    '/portfolio/locarno/7.jpg',
                    '/portfolio/locarno/8.jpg',
                ],
            },
            {
                title: "Jungfraujoch",
                place: "Berneński Oberland",
                category: "tourism",
                description: "Top of Europe. Lodowce, lodowe tunele i biała cisza ponad chmurami.",
                cover: '/portfolio/jungfraujoch/1.jpg',
                photos: [
                    '/portfolio/jungfraujoch/1.jpg',
                    '/portfolio/jungfraujoch/2.jpg',
                    '/portfolio/jungfraujoch/3.jpg',
                    '/portfolio/jungfraujoch/4.jpg',
                    '/portfolio/jungfraujoch/5.jpg',
                    '/portfolio/jungfraujoch/6.jpg',
                    '/portfolio/jungfraujoch/7.jpg',
                    '/portfolio/jungfraujoch/8.jpg',
                    '/portfolio/jungfraujoch/9.jpg',
                ],
            },
            {
                title: "Harder Kulm",
                place: "Berneński Oberland",
                category: "tourism",
                description: "Punkt widokowy nad Interlaken, panorama Eigeru, Mönch i Jungfrau.",
                cover: '/portfolio/harder-kulm/1.jpg',
                photos: [
                    '/portfolio/harder-kulm/1.jpg',
                    '/portfolio/harder-kulm/2.jpg',
                    '/portfolio/harder-kulm/3.jpg',
                    '/portfolio/harder-kulm/4.jpg',
                    '/portfolio/harder-kulm/5.jpg',
                    '/portfolio/harder-kulm/6.jpg',
                    '/portfolio/harder-kulm/7.jpg',
                    '/portfolio/harder-kulm/8.jpg',
                ],
            },
            {
                title: "Grindelwald First",
                place: "Berneński Oberland",
                category: "tourism",
                description: "W Alpach Berneńskich, szlaki, kolejka i widoki, które zatrzymują w miejscu.",
                cover: '/portfolio/grindelwald-first/1.jpg',
                photos: [
                    '/portfolio/grindelwald-first/1.jpg',
                    '/portfolio/grindelwald-first/2.jpg',
                    '/portfolio/grindelwald-first/3.jpg',
                    '/portfolio/grindelwald-first/4.jpg',
                ],
            },
            {
                title: "Berno",
                place: "Szwajcaria",
                category: "tourism",
                description: "Stolica Szwajcarii w jesiennym świetle, arkady, rzeka Aare i klimatyczne uliczki.",
                cover: '/portfolio/bern/1.jpg',
                photos: [
                    '/portfolio/bern/1.jpg',
                    '/portfolio/bern/2.jpg',
                    '/portfolio/bern/3.jpg',
                    '/portfolio/bern/4.jpg',
                    '/portfolio/bern/5.jpg',
                    '/portfolio/bern/6.jpg',
                    '/portfolio/bern/7.jpg',
                    '/portfolio/bern/8.jpg',
                    '/portfolio/bern/9.jpg',
                    '/portfolio/bern/10.jpg',
                    '/portfolio/bern/11.jpg',
                    '/portfolio/bern/12.jpg',
                ],
            },
            {
                title: "Algarve",
                place: "Portugalia",
                category: "tourism",
                description: "Klify, ocean i światło wybrzeża Algarve, kadrowane jak pocztówka.",
                cover: '/portfolio/algarve/1.jpg',
                photos: [
                    '/portfolio/algarve/1.jpg',
                    '/portfolio/algarve/2.jpg',
                    '/portfolio/algarve/3.jpg',
                    '/portfolio/algarve/4.jpg',
                    '/portfolio/algarve/5.jpg',
                    '/portfolio/algarve/6.jpg',
                    '/portfolio/algarve/7.jpg',
                    '/portfolio/algarve/8.jpg',
                ],
            },
            {
                title: "Veoli Botanica",
                place: "Sesja produktowa",
                category: "products",
                description: "Sesja dla polskiej marki kosmetyków botanicznych Veoli, naturalna paleta i czyste kadry.",
                cover: '/portfolio/veoli-botanica/1.jpg',
                photos: [
                    '/portfolio/veoli-botanica/1.jpg',
                    '/portfolio/veoli-botanica/2.jpg',
                    '/portfolio/veoli-botanica/3.jpg',
                    '/portfolio/veoli-botanica/4.jpg',
                    '/portfolio/veoli-botanica/5.jpg',
                    '/portfolio/veoli-botanica/6.jpg',
                    '/portfolio/veoli-botanica/7.jpg',
                    '/portfolio/veoli-botanica/8.jpg',
                ],
            },
            {
                title: "Emu",
                place: "Sesja produktowa",
                category: "products",
                description: "Sesja produktowa dla marki Emu. Czyste światło, ciepłe tony i kadry, które oddają charakter produktu.",
                cover: '/portfolio/emu/1.jpg',
                photos: [
                    '/portfolio/emu/1.jpg',
                    '/portfolio/emu/2.jpg',
                    '/portfolio/emu/3.jpg',
                    '/portfolio/emu/4.jpg',
                    '/portfolio/emu/5.jpg',
                    '/portfolio/emu/6.jpg',
                    '/portfolio/emu/7.jpg',
                    '/portfolio/emu/8.jpg',
                    '/portfolio/emu/9.jpg',
                    '/portfolio/emu/10.jpg',
                    '/portfolio/emu/11.jpg',
                ],
            },
            {
                title: "So Bloomy",
                place: "Sesja produktowa",
                category: "products",
                description: "Sesja produktowa dla marki So Bloomy. Jesienna paleta, ciepłe światło i kadry budujące nastrój marki.",
                cover: '/portfolio/autumn-product/6.jpg',
                photos: [
                    '/portfolio/autumn-product/1.jpg',
                    '/portfolio/autumn-product/2.jpg',
                    '/portfolio/autumn-product/3.jpg',
                    '/portfolio/autumn-product/4.jpg',
                    '/portfolio/autumn-product/5.jpg',
                    '/portfolio/autumn-product/6.jpg',
                    '/portfolio/autumn-product/7.jpg',
                    '/portfolio/autumn-product/8.jpg',
                ],
            },
            {
                title: "Dilmah",
                place: "Sesja produktowa",
                category: "products",
                description: "Świąteczna sesja produktowa dla Dilmah. Ciepłe światło, klimat i detale dla marek hotelarskich i lifestyle.",
                cover: '/portfolio/christmas/2.jpg',
                photos: [
                    '/portfolio/christmas/1.jpg',
                    '/portfolio/christmas/2.jpg',
                    '/portfolio/christmas/3.jpg',
                    '/portfolio/christmas/4.jpg',
                    '/portfolio/christmas/5.jpg',
                    '/portfolio/christmas/6.jpg',
                    '/portfolio/christmas/7.jpg',
                    '/portfolio/christmas/8.jpg',
                ],
            },
            {
                title: "Big Active",
                place: "Sesja produktowa",
                category: "products",
                description: "Sesja produktowa marki Big Active. Herbata w ciepłej kompozycji, mood prosto z liścia.",
                cover: '/portfolio/tea-product/1.jpg',
                photos: [
                    '/portfolio/tea-product/1.jpg',
                    '/portfolio/tea-product/2.jpg',
                    '/portfolio/tea-product/3.jpg',
                    '/portfolio/tea-product/4.jpg',
                    '/portfolio/tea-product/5.jpg',
                    '/portfolio/tea-product/6.jpg',
                    '/portfolio/tea-product/7.jpg',
                    '/portfolio/tea-product/8.jpg',
                ],
            },
        ],
    },
    brands: {
        label: 'Z KIM PRACOWAŁAM',
        items: [
            { name: 'Jungfrau Region' },
            { name: 'Taksidi' },
            { name: 'Canon' },
            { name: 'Lucerne Tourism' },
            { name: 'Titlis' },
            { name: 'Grindelwald First' },
            { name: 'Jungfraujoch' },
            { name: 'Eiger Lodge' },
            { name: 'Adelboden-Lenk-Kandersteg' },
            { name: 'Zentralbahn' },
            { name: 'Lake Lucerne' },
            { name: 'Tara Style' },
            { name: 'Dilmah' },
            { name: 'Everest Outdoor' },
            { name: 'Emu Australia' },
            { name: 'Krups' },
        ],
    },
    faq: {
        label: "FAQ",
        title: "Najczęstsze pytania.",
        items: [
            { q: "Ile kosztuje sesja content w Szwajcarii?",
                a: "Cena zależy całkowicie od skali i zakresu projektu: pojedyncza sesja zdjęciowa, pakiet z reelami czy kompleksowe prowadzenie social mediów wyceniane są inaczej. Każdą ofertę przygotowuję pod konkretne potrzeby marki, więc chętnie zrobię dla Ciebie dopasowaną wycenę." },
            { q: "Co zawiera pakiet content creation?",
                a: "Większość projektów obejmuje cały proces twórczy: planowanie mood'u i pomysłu na sesję, fotografię, krótkie wideo tam, gdzie pasuje, edycję i końcowe pliki, których możesz używać na własnych kanałach. W zależności od pakietu możemy też wspólnie opublikować materiał na {'@'}travellingdominika." },
            { q: "Czy podróżujesz na sesje?",
                a: "Tak, dojadę do każdego miejsca w Szwajcarii i realizuję też projekty w innych krajach. Koszty dojazdu do dalszych lokalizacji są zawsze transparentnie wyliczone w wycenie." },
            { q: "Jaka jest różnica między content creation a social media management?",
                a: "Content creation oznacza, że tworzę dla Ciebie zdjęcia, reele i storytelling, a Ty publikujesz je na swoich kanałach. Social media management to kompleksowe prowadzenie profili od A do Z: planowanie, publikacja, copy, obsługa wiadomości, całość na Instagramie, Facebooku, LinkedInie albo TikToku." },
            { q: "Ile trwa sesja w hotelu lub restauracji?",
                a: "Skoncentrowane pół dnia na miejscu wystarcza dla większości butikowych hoteli i restauracji. Większe obiekty lub sesje z wieloma deliverable'ami zwykle zajmują pełny dzień lub dwa. Edycja i przekazanie materiałów zajmuje od jednego do dwóch tygodni." },
            { q: "Czy mogę używać zdjęć i reeli na swoich kanałach?",
                a: "Tak. Pakiety zdjęć i reeli zawierają prawa do użytku na własnych kanałach marki, stronie i w materiałach marketingowych. Szczególne kwestie wyłączności czy użycia w płatnych reklamach ustalamy z góry." },
            { q: "Czy tworzysz też krótkie wideo, Reels i TikToka?",
                a: "Tak, short-form video to ważna część mojej pracy. Pakiety reeli zawierają materiały 30 do 45 sekund, mogę też regularnie dostarczać tygodniowe lub miesięczne reele obok fotografii." },
            { q: "Czy pracujesz tylko z hotelami, czy też z restauracjami, regionami turystycznymi i markami produktowymi?",
                a: "Pracuję z różnymi branżami. Większość projektów to hotele i hospitality, ale tworzę też content dla regionów turystycznych, restauracji i kawiarni, lokalnych biznesów i marek produktowych. Wśród ostatnich klientów produktowych są Veoli Botanica, So Bloomy, Dilmah i Big Active." },
            { q: "Z jakim wyprzedzeniem warto rezerwować sesję?",
                a: "Dwa do czterech tygodni wyprzedzenia jest idealne, żebyśmy mogli dobrze zaplanować mood, lokalizację i terminy. W szczycie sezonu jak lato w Ticino czy zima w Berneńskim Oberlandzie warto rezerwować jeszcze wcześniej." },
        ],
    },
    seo: {
        home: {
            title: "Twórca treści dla hoteli i turystyki w Szwajcarii",
            description: "Cześć, jestem Dominika, twórczyni treści i fotografka z bazą w Szwajcarii. Pracuję z hotelami, turystyką i markami. Fotografia, reele, social.",
        },
        portfolio: {
            title: "Portfolio · Fotografia hoteli, turystyki i produktów w Szwajcarii",
            description: "Wybrane projekty z całej Szwajcarii: hotele, turystyka i sesje produktowe.",
        },
        hotels: {
            title: "Twórca treści dla hoteli w Szwajcarii · Portfolio",
            description: "Sesje hotelowe i współprace z hotelami w Szwajcarii. Butikowa fotografia hospitality od Dominiki.",
        },
        tourism: {
            title: "Fotografia turystyczna w Szwajcarii · Portfolio",
            description: "Treści turystyczne i podróżnicze z całej Szwajcarii: Ticino, Lucerna, Berneński Oberland i nie tylko.",
        },
        products: {
            title: "Fotografia produktowa i content marek · Portfolio",
            description: "Sesje produktowe dla marek skincare, food i lifestyle. Ostatni klienci: Veoli Botanica, So Bloomy, Dilmah, Big Active.",
        },
        privacy: {
            title: "Polityka prywatności",
            description: "Jak travellingdominika.com obchodzi się z Twoimi danymi: bez cookies, bez śledzenia, bez analityki.",
        },
    },
    contact: {
        label: 'KONTAKT',
        title: 'Dowiedz się, co dla Ciebie mogę zrobić.',
        sub: 'Napisz, z przyjemnością odpowiem na każdą wiadomość.',
        email: "dominikatrunowicz{'@'}gmail.com",
        cta: 'Napisz do mnie',
    },
    privacy: {
        label: 'PRYWATNOŚĆ',
        title: 'Polityka prywatności',
        updated: 'Ostatnia aktualizacja: czerwiec 2026',
        intro: 'Ta strona to moje prywatne portfolio. Trzymam ją prostą i zbieram jak najmniej danych — oto co to oznacza w praktyce.',
        sections: [
            {
                heading: 'Bez cookies, bez śledzenia',
                body: 'travellingdominika.com nie używa plików cookies, analityki ani żadnego śledzenia przez podmioty trzecie. Nic na temat Twojej wizyty nie jest zapisywane ani profilowane.',
            },
            {
                heading: 'Hosting',
                body: 'Strona jest serwowana jako pliki statyczne przez Cloudflare, który może przetwarzać podstawowe dane techniczne żądania (np. adres IP), aby dostarczać strony i chronić przed nadużyciami. Szczegóły znajdziesz w polityce prywatności Cloudflare.',
            },
            {
                heading: 'Kontakt e-mail',
                body: 'Jeśli napiszesz do mnie e-mail, używam Twojej wiadomości i adresu wyłącznie po to, by Ci odpowiedzieć. Nie dodaję Cię do żadnej listy ani nie udostępniam Twoich danych nikomu.',
            },
            {
                heading: 'Linki do social mediów',
                body: 'Linki do Instagrama i LinkedIn przeniosą Cię na te platformy, które mają własne polityki prywatności.',
            },
            {
                heading: 'Pytania',
                body: 'Masz pytania o swoje dane? Po prostu napisz do mnie:',
            },
        ],
    },
    footer: {
        contactLabel: 'KONTAKT',
        email: "dominikatrunowicz{'@'}gmail.com",
        responseTime: 'Odpowiadam w 24h.',
        socialLabel: 'SOCIAL',
        instagramLabel: 'Instagram',
        instagramUrl: 'https://instagram.com/travellingdominika',
        linkedinLabel: 'LinkedIn',
        linkedinUrl: 'https://www.linkedin.com/in/dominika-trunowicz-317403274/',
        copyright: '© 2026 travellingdominika',
        privacy: 'Polityka prywatności',
        privacyUrl: '#privacy',
    },
};
